export default {
  type: 'slider',
  lazyGlide: {
    selector: '.lazy[data-src]',
    wokenSlide: 'slider__slide--woken'
  },
  classes: {
    direction: {
      ltr: 'slider--ltr',
      rtl: 'slider--rtl'
    },
    slider: 'slider--slider',
    carousel: 'slider--carousel',
    swipeable: 'slider--swipeable',
    dragging: 'slider--dragging',
    cloneSlide: 'slider__slide--clone',
    activeNav: 'slider__bullet--active',
    activeSlide: 'slider__slide--active',
    disabledArrow: 'slider__arrow--disabled'
  }
}
